import React, { memo, useMemo } from 'react';

import { CancelIcon, ConfirmIcon, EditPenIcon, ResetIcon } from '@sharedCR/coreDesignSystem/icons';
import { ActionCellButtonCDS } from '@sharedCR/coreDesignSystem/Table/TableCDS/cellContent';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';
import { getConditionalArray } from 'utils/data';

import { isPending } from '../ExceptionsTable.utils';

const RowActionButton = ({ rowData }) => {
  const { canEdit, canApprove, status, onEdit, onApprove, onDeny, onWithdraw } = rowData;

  const pending = isPending(status);
  const showEdit = canEdit && pending;
  const showDecisionActions = canApprove && pending;
  const showWithdraw = canEdit && pending;

  const items = useMemo(
    () => [
      ...getConditionalArray(showEdit, [
        {
          text: 'Edit',
          onClick: () => onEdit(rowData),
          icon: <EditPenIcon size={IconSize[20]} />,
        },
      ]),
      ...getConditionalArray(showDecisionActions, [
        {
          text: 'Approve',
          onClick: () => onApprove(rowData),
          icon: <ConfirmIcon size={IconSize[20]} />,
        },
        {
          text: 'Deny',
          onClick: () => onDeny(rowData),
          icon: <CancelIcon size={IconSize[20]} />,
        },
      ]),
      ...getConditionalArray(showWithdraw, [
        {
          text: 'Withdraw',
          onClick: () => onWithdraw(rowData),
          icon: <ResetIcon size={IconSize[20]} />,
        },
      ]),
    ],
    [rowData, showEdit, showDecisionActions, showWithdraw, onEdit, onApprove, onDeny, onWithdraw],
  );

  return <ActionCellButtonCDS isHidden={!items.length} items={items} />;
};

RowActionButton.propTypes = {
  rowData: PropTypes.shape({
    id: PropTypes.string.isRequired,
    onEdit: PropTypes.func.isRequired,
    onApprove: PropTypes.func.isRequired,
    onDeny: PropTypes.func.isRequired,
    onWithdraw: PropTypes.func.isRequired,
    status: PropTypes.string,
    canEdit: PropTypes.bool,
    canApprove: PropTypes.bool,
  }).isRequired,
};

export default memo(RowActionButton);
